// ComplaintPolicy.jsx
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { TranslationNamespace } from '../resource/translationNamespace.js';
import { NULL_FUNCTION } from '../resource/defaults.js';
import { LegalPageLayout } from '../component/LegalPageLayout.jsx';

const ComplaintPolicy = ({
  t,
  goBack = NULL_FUNCTION,
  handleMailTo = NULL_FUNCTION,
}) => (
  <LegalPageLayout
    title={t('complaint_policy_title', { ns: TranslationNamespace.SETTINGS })}
    htmlString={t('complaint_policy_seo_description', {
      ns: TranslationNamespace.SETTINGS,
      interpolation: { prefix: '#__NONE__#', suffix: '#__NONE__#' },
    })}
    goBack={goBack}
    onMailTo={handleMailTo}
  />
);

ComplaintPolicy.propTypes = {
  goBack: PropTypes.func,
  handleMailTo: PropTypes.func,
  t: PropTypes.func.isRequired,
};

export { ComplaintPolicy };
export default withTranslation()(memo(ComplaintPolicy));
